<template>
  <div class="showTitle">
    <div class="left">
      <div class="round"></div>
      <div class="title_text">{{title}} <span style="font-size: 12px;color: #999999;">{{description}}</span></div>
      <div v-if="showRequired" class="required"></div>
    </div>
    <div class="right">
      <slot name="btn"></slot>
    </div>
  </div>
</template>

<script>
export default {
	name:'ptShowTitle',
  props:{
    title:{
      type:String,
      default:'',
    },
    showRequired:{
      type:Boolean,
      default:true,
    },
	  description:{
			type:String,
		  default:''
	  }
  },
}
</script>

<style scoped lang="less">
 .showTitle{
   display: flex;
   justify-content: space-between;
   align-items: center;
   height: 50px;
   .left{
     display: flex;
     flex: auto;
     align-items: center;
     .round{
       background: #FABE00;
       width: 12px;
       height: 12px;
       border-radius: 50%;
       margin-right: 10px;
     }
     .title_text{
       font-size: 12px;
       color: #333333;
	     font-weight: 500;
       letter-spacing: 0;

     }
     .required:after{
       display: inline-block;
       margin-left: 4px;
       content: '*';
       line-height: 1;
       font-size: 14px;
       color: #f5222d;
     }
   }
 }
</style>